module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/operator.be05c161.svg";